import { Outlet } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export function RootComponent() {
  return (
    <>
      <Outlet />

      {/* {import.meta.env.DEV ? (
        <TanStackRouterDevtools />
      ) : null} */}
    </>
  )
}